import { PermissionsType } from '@/common/permissionsConst';
import MicrogridStrategy from '.';
import MicrogridStrategyCoinfiguration from './Configuration';

const routes = [
  {
    path: '/microgrid/strategy/management',
    permission:PermissionsType.P_MICROGRID_POLICY_MANAGEMENT,
    element: <MicrogridStrategy />,
  },
  {
    path: '/microgrid/strategy/management/configuration',
    permission: '',
    element: <MicrogridStrategyCoinfiguration />,
  },
];

export default routes;
